import React from 'react';
import PropTypes from 'prop-types';
import { GenericPaginator } from 'web-ui-components/lib/data/filter-and-search';

const PagingControl = ({ currentPage, totalNumberOfPages, onPageChange }) => {
	if (totalNumberOfPages > 1) {
		return (
			<div data-test-id="account-picker-paging-control" className="account-picker__pagingControl">
				<GenericPaginator
					currentPage={currentPage}
					numberOfPages={totalNumberOfPages}
					className="u-margin-right-0"
					onChangePage={onPageChange}
				/>
			</div>
		);
	}
	return null;
};

PagingControl.propTypes = {
	currentPage: PropTypes.number.isRequired,
	totalNumberOfPages: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
};

export default PagingControl;
